import React from 'react';
import DashboardLayout from '../../layouts/DashboardLayout';
import { V2NavSection } from '../../components/navigation/SideNav';
import './PlaceholderPage.css';

interface PlaceholderPageProps {
  section: V2NavSection;
  title: string;
}

/**
 * Per-section copy for surfaces that are routed but not built on the web.
 *
 * The generic "upcoming design iterations" line was actively misleading for
 * Messages: direct messages ARE built and shipped — server, API and the whole
 * mobile UI (DM1–DM4) — it is only the web client half that is missing. A beta
 * tester reading the old text would conclude the feature does not exist and
 * never try it on their phone.
 */
const SECTION_COPY: Partial<Record<V2NavSection, string>> = {
  messages: 'Direct messages are live in the mobile app — the web version is still being built. Open Wayplume on your phone to read and reply.',
};

const PlaceholderPage: React.FC<PlaceholderPageProps> = ({ section, title }) => {
  return (
    <DashboardLayout activeSection={section}>
      <div className="v2-placeholder-page">
        <h1>{title}</h1>
        <p>{SECTION_COPY[section] || 'This section will be built in upcoming design iterations.'}</p>
      </div>
    </DashboardLayout>
  );
};

export default PlaceholderPage;
